module.exports = __webpack_public_path__ + "static/haas-red-ca6aa533e3a4efffa74b1ef06ed37933.png";